import { render, staticRenderFns } from "./icon-spacing.vue?vue&type=template&id=c4efe268"
import script from "./icon-spacing.vue?vue&type=script&lang=js"
export * from "./icon-spacing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports